import * as React from "react"
import { Alert } from "@mui/material"

import { isTruncated, rowLimit, totalRows, isLoadingTable } from "./@signals"


export default function TruncationAlert() {
    if (isLoadingTable.value || !isTruncated.value) return null

    const limit = rowLimit.value.toLocaleString('en-US')
    const total = totalRows.value.toLocaleString('en-US')

    return (
        <Alert severity="warning" sx={{ py: 0.5, mb: 2 }}>
            Showing the first <strong>{limit}</strong> of <strong>{total}</strong> matching rows.
            The table search and <em>Group By</em> only look at the loaded rows, so a product
            outside this window will not show up — narrow the query with <strong>Brands</strong>,
            <strong> Market</strong> or <strong>Recent data (30d)</strong> to reach it.
        </Alert>
    )
}
